import { apiVersion } from '../apis.const';
import { transformResponse } from '../apis.util';
import { baseApi } from '../base.api';

/**
 * Create APIs
 */
export const serviceInterruptionsApi = baseApi.injectEndpoints({
  overrideExisting: false,

  endpoints: (build) => ({
    fetchServiceInterruptions: build.query<FetchServiceInterruptionsRes, FetchServiceInterruptionsReq>({
      query: ({ orgSlug }) => ({
        url: `/${orgSlug}/${apiVersion}/service-interruption`,
      }),
      transformResponse,
      providesTags: ['ServiceInterruptions'],
    }),

    fetchServiceInterruption: build.query<FetchServiceInterruptionRes, FetchServiceInterruptionReq>({
      query: ({ orgSlug, id }) => ({
        url: `/${orgSlug}/${apiVersion}/service-interruption/${id}`,
      }),
      transformResponse,
    }),

    createServiceInterruption: build.mutation<CreateServiceInterruptionRes, CreateServiceInterruptionReq>({
      query: ({ orgSlug, ...rest }) => ({
        url: `/${orgSlug}/${apiVersion}/service-interruption`,
        method: 'POST',
        body: rest,
      }),
      transformResponse,
      invalidatesTags: ['ServiceInterruptions'],
    }),

    createServiceInterruptionWithoutAuth: build.mutation<
      CreateServiceInterruptionWithoutAuthRes,
      CreateServiceInterruptionWithoutAuthReq
    >({
      query: ({ orgSlug, ...rest }) => ({
        url: `/${orgSlug}/token/service-interruption`,
        method: 'POST',
        body: rest,
      }),
      transformResponse,
    }),

    deleteServiceInterruption: build.mutation<DeleteServiceInterruptionRes, DeleteServiceInterruptionReq>({
      query: ({ orgSlug, id }) => ({
        url: `/${orgSlug}/${apiVersion}/service-interruption/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ServiceInterruptions'],
    }),
  }),
});

/**
 * Hooks
 */
export const {
  useFetchServiceInterruptionsQuery,
  useFetchServiceInterruptionQuery,
  useCreateServiceInterruptionMutation,
  useCreateServiceInterruptionWithoutAuthMutation,
  useDeleteServiceInterruptionMutation,
} = serviceInterruptionsApi;

/**
 * Types
 */
type OrgSlug = {
  orgSlug: string;
};

export type ServiceInterruption = {
  building_id: number;
  clean_code_zone_id: number;
  clean_code_zone_cleaning_schedule_id: number | null;
  comment: string;
  status: string;
  created_by: number;
  created_at: string | null;
  updated_at: string | null;
};

type FetchServiceInterruptionsRes = Array<ServiceInterruption & { id: number }>;
type FetchServiceInterruptionsReq = OrgSlug;
type FetchServiceInterruptionRes = any;
type FetchServiceInterruptionReq = OrgSlug & { id: number };
type CreateServiceInterruptionRes = any;
type CreateServiceInterruptionReq = OrgSlug & ServiceInterruption;
type CreateServiceInterruptionWithoutAuthRes = any;
type CreateServiceInterruptionWithoutAuthReq = OrgSlug & ServiceInterruption;
type DeleteServiceInterruptionRes = any;
type DeleteServiceInterruptionReq = OrgSlug & { id: number };
